import { FadeUp, SlideTitle, SlideConclusion } from "../Deck";

const GAPS = [
  {
    h: "After the order",
    p: "Doctors rarely see whether sessions happened or how the patient progressed.",
  },
  {
    h: "For the patient",
    p: "Finding a verified physiotherapist is left to the patient.",
  },
  {
    h: "For the clinician",
    p: "Uneven caseloads, paper notes, no link back to the doctor.",
  },
  {
    h: "At the workplace",
    p: "Strain and injury with no rehabilitation within reach of the shift.",
  },
];

export default function Slide02Gap() {
  return (
    <div>
      <SlideTitle>
        Where rehabilitation <em className="italic text-gold">breaks down</em>
      </SlideTitle>
      <div className="mt-12 grid gap-x-8 gap-y-10 sm:grid-cols-2 lg:grid-cols-4">
        {GAPS.map((g, i) => (
          <FadeUp
            key={g.h}
            delay={0.1 + i * 0.08}
            className="border-t border-ink/15 pt-6"
          >
            <div className="font-mono text-[11px] tracking-[0.2em] text-teal">
              {String(i + 1).padStart(2, "0")}
            </div>
            <h3 className="mt-4 text-lg font-semibold tracking-tight">
              {g.h}
            </h3>
            <p className="mt-2.5 text-sm leading-relaxed text-mut">{g.p}</p>
          </FadeUp>
        ))}
      </div>
      <SlideConclusion>PranIQ closes each of these gaps.</SlideConclusion>
    </div>
  );
}
